import styled from 'styled-components';

export const Container = styled.div`
  background: ${props => props.theme.color.white};
  border: 1px solid ${props => props.theme.color.neutral60};
  box-sizing: border-box;
  border-radius: 4px;
  padding: 16px;
  margin-bottom: 24px;

  h5 {
    font-size: ${props => props.theme.fontSize.md};
    line-height: 20px;
    color: ${props => props.theme.color.neutral};
    margin-bottom: 10px;
    + strong {
      color: ${props => props.theme.color.neutral};
    }
  }

  .item {
    display: flex;
    justify-content: space-between;
    strong {
      display: table;
      margin-top: 5px;
    }
    p {
      line-height: 20px;
    }
  }

  .itemTicket {
    display: flex;
    a {
      display: inline-flex;
      text-decoration: none;
    }
    p {
      line-height: 20px;
      font-size: 13px;
      color: ${props => props.theme.color.primary};
      font-weight: 500;
      margin-left: 5px;
    }
  }

  > h3 {
    font-size: ${props => props.theme.fontSize.md};
    color: ${props => props.theme.color.neutral};
    font-weight: bold;
    margin-bottom: ${props => props.theme.spacing.sm};
  }

  hr {
    display: block;
    width: 100%;
    height: 1px;
    background-color: ${props => props.theme.color.neutral60};
    margin: 16px 0px;
    border: none;
  }
  > p {
    font-size: ${props => props.theme.fontSize.md};
    color: ${props => props.theme.color.neutral};
    margin-bottom: 8px;
    line-height: 20px;
  }
  strong {
    font-size: ${props => props.theme.fontSize.md};
    color: ${props => props.theme.color.primary};
    font-weight: bold;
  }

  .information-text {
    font-size: ${props => props.theme.fontSize.xs};
    color: #697277;
    margin-top: 16px;
  }

  .details {
    display: flex;
    flex-flow: row wrap;
    justify-content: space-between;
    .new-line {
      flex-wrap: wrap;
      justify-self: flex-start;
    }
    > p {
      font-size: ${props => props.theme.fontSize.xs};
      color: ${props => props.theme.color.neutral};
      line-height: 20px;
    }
    > h3 {
      font-size: ${props => props.theme.fontSize.md};
      color: ${props => props.theme.color.neutral};
      font-weight: bold;
      margin-bottom: 10px;
    }
    .small {
      font-size: ${props => props.theme.fontSize.xs};
      color: #697277;
    }

    .medium {
      font-size: ${props => props.theme.fontSize.md};
    }
    .big {
      font-size: ${props => props.theme.fontSize.lg};
      font-weight: 500;
      color: ${props => props.theme.color.neutral90};
    }
    .metainfo {
      display: flex;
      flex-direction: column;
      align-items: flex-end;

      strong {
        font-size: ${props => props.theme.fontSize.lg};
        margin-bottom: 2px;
      }

      span {
        margin-top: 5px;
        font-size: ${props => props.theme.fontSize.md};
        color: ${props => props.theme.color.neutral};
      }
    }
  }

  .price {
    display: flex;
    justify-content: space-between;
    justify-content: flex-end;
    margin-bottom: 16px;
  }

  .seller {
    font-size: ${props => props.theme.fontSize.xs};
    margin: 8px 0;
    display: block;
    strong {
      color: initial;
      font-size: ${props => props.theme.fontSize.xs};
    }
  }

  .large {
    margin: 0;
    padding: 0;
    margin-bottom: 3px;
    color: ${props => props.theme.color.neutral90};
  }

  h4 {
    font-size: ${props => props.theme.fontSize.md};
    line-height: 24px;
    font-weight: 500;
    text-transform: uppercase;
    color: ${props => props.theme.color.neutral};
    margin-bottom: 5px;
  }
`;
